import React from 'react'
import { DialogContent } from '@material-ui/core'
import { useDialogStyle } from './ResponsiveDialog'
import clsx from 'clsx'

const ResponsiveDialogContent = (props) => {
  const classes = useDialogStyle()
  return <DialogContent className={clsx(classes.dialogContent)} {...props} />
}

export default ResponsiveDialogContent
